<section class="payment-return-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-5 text-center">

        <div class="return-card" *ngIf="status === 'processing'">
          <mat-spinner diameter="56" class="mx-auto mb-4"></mat-spinner>
          <h2>Confirming your payment…</h2>
          <p class="text-muted">Please wait, do not close this page.</p>
        </div>

        <div class="return-card success-card" *ngIf="status === 'success'">
          <mat-icon class="result-icon success-icon">check_circle</mat-icon>
          <h2>Payment Successful!</h2>
          <p>{{message}}</p>
          <button mat-raised-button class="submit mt-4" (click)="goToBookings()">
            View My Bookings
          </button>
        </div>

        <div class="return-card pending-card" *ngIf="status === 'pending'">
          <mat-icon class="result-icon pending-icon">schedule</mat-icon>
          <h2>Payment Pending</h2>
          <p>{{message}}</p>
          <button mat-raised-button class="submit mt-4" (click)="goToBookings()">
            View My Bookings
          </button>
        </div>

        <div class="return-card error-card" *ngIf="status === 'error'">
          <mat-icon class="result-icon error-icon">error</mat-icon>
          <h2>Payment Issue</h2>
          <p>{{message}}</p>
          <button mat-raised-button class="submit mt-4" (click)="goToBookings()">
            Go to My Bookings
          </button>
        </div>

      </div>
    </div>
  </div>
</section>
